<template>
  <div class="personal-header__authorize-list">
    <button class="personal-header__authorize-item" @click.prevent="openLogin">
      Вход
    </button>
    <span class="personal-header__authorize-seporator">/</span>
    <button class="personal-header__authorize-item" @click.prevent="openRegistration">
      Регистрация
    </button>
    <modal-vue-d
      name="auth-modal"
      :width="420"
      @opened="openedModal"
    >
      <auth-m ref="auth" :show-title="true" />
    </modal-vue-d>
  </div>
</template>

<script>
import ModalVueD from '@/js/vue/ModalVueD';
import AuthM from '@/js/vue/Auth/AuthM';
import eventBus from '@/js/helpers/orderBus';

export default {
  name: 'AuthButtonsD',
  components: {
    AuthM,
    ModalVueD,
  },
  data: () => ({
    state: '',
  }),
  created() {
    if (!window.book24) {
      window.book24 = {};
    }
    if (!window.book24.vmInstance) {
      window.book24.vmInstance = {};
    }
    window.book24.vmInstance.AuthButtonsD = this;
  },
  mounted() {
    eventBus.$on('call-auth-form', (data) => {
      this.state = data;
    });
  },
  methods: {
    openModal() {
      this.$modal.show('auth-modal');
    },
    openLogin() {
      this.state = 'login';
      this.openModal();
    },
    openRegistration() {
      this.state = 'registration';
      this.openModal();
    },
    openedModal() {
      this.$refs.auth.state = this.state;
    },
  },
};
</script>
